import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HammerRatingComponent } from './hammer-rating.component';

@NgModule({
  declarations: [HammerRatingComponent],
  imports: [CommonModule, IonicModule],
  exports: [HammerRatingComponent],
})
export class HammerRatingModule {}
